import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import Home from "./pages/Home";
import ProductDetail from "./pages/ProductDetail";
import PreBook from "./pages/PreBook";
import ContactPage from "./pages/ContactPage";
import Allproduct from "./pages/Allproduct";
import CategoryProducts from "./pages/CategoryProducts";
import Cart from "./pages/Cart";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />

      <Navbar />
      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/prebook/:id" element={<PreBook />} />
        <Route path="/catalog" element={<Allproduct />} />
        <Route path="/category/:cid" element={<CategoryProducts />} />
        <Route path="/cart" element={<Cart />} />
      </Routes>

      <Footer />
      <FloatingWhatsApp />
    </BrowserRouter>
  );
}

export default App;